import { render } from "./process-list.vue?vue&type=template&id=bcf4c6b4"
import script from "./process-list.vue?vue&type=script&lang=js"
export * from "./process-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__